<div class="consolidado-section">
  <div class="consolidado-header">
    <h2>{{ 'Reporte Consolidado — Batch por Mês' | translate }}</h2>

    <div class="consolidado-filtros">
      <div class="filtro">
        <label for="cboConsolidadoPais">{{ 'País' | translate }}</label>
        <select id="cboConsolidadoPais" [(ngModel)]="filtro.countryCode">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let p of listPaises; trackBy: trackByCountryCode" [value]="p.countryCode">{{ p.name }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboConsolidadoAno">{{ 'Ano' | translate }}</label>
        <select id="cboConsolidadoAno" [(ngModel)]="filtro.ano">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let a of listAnos; trackBy: trackByIndex" [value]="a">{{ a }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboConsolidadoMes">{{ 'Mês' | translate }}</label>
        <select id="cboConsolidadoMes" [(ngModel)]="filtro.mes">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let m of listMeses; trackBy: trackByIndex" [value]="m.value">{{ m.label | translate }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="txtConsolidadoDataInicial">{{ 'Desde' | translate }}</label>
        <input type="text" id="txtConsolidadoDataInicial" placeholder="dd/mm/aaaa" maxlength="10"
               [ngModel]="filtro.dataInicial" (input)="formatarDataInput($event, 'dataInicial')">
      </div>

      <div class="filtro">
        <label for="txtConsolidadoDataFinal">{{ 'Hasta' | translate }}</label>
        <input type="text" id="txtConsolidadoDataFinal" placeholder="dd/mm/aaaa" maxlength="10"
               [ngModel]="filtro.dataFinal" (input)="formatarDataInput($event, 'dataFinal')">
      </div>

      <button class="btn-buscar" (click)="buscar()"
        [disabled]="!filtro.countryCode || !filtro.ano || !filtro.mes || isLoading">
        <span *ngIf="!isLoading">{{ 'Consultar' | translate }}</span>
        <span *ngIf="isLoading">{{ 'Carregando...' | translate }}</span>
      </button>

      <button class="btn-limpar" (click)="limpar()" [disabled]="isLoading">
        {{ 'Limpar' | translate }}
      </button>

      <button class="btn-exportar" (click)="exportarCsv()"
        *ngIf="dados.length > 0" [disabled]="isLoading">
        {{ '↓ Exportar CSV' | translate }}
      </button>

      <label class="toggle-riRm" *ngIf="dados.length > 0">
        <input type="checkbox" [(ngModel)]="mostrarRiRm">
        {{ 'Impresso / Manuscrito' | translate }}
      </label>
    </div>
  </div>

  <!-- Tabela -->
  <div class="consolidado-table-wrap">
    <table class="consolidado-table mat-elevation-z2">

      <thead>
        <tr class="col-header-row">
          <th>{{ 'FechaProceso' | translate }}</th>
          <th>{{ 'Envio' | translate }}</th>
          <th>{{ 'Total Imgs' | translate }}</th>
          <th>{{ 'Con Error' | translate }}</th>
          <th>{{ 'No son Rxs' | translate }}</th>
          <th>{{ 'En Cola' | translate }}</th>
          <th>{{ 'Procesadas' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Im' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Man' | translate }}</th>
          <th>{{ 'Validas APPI' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Im' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Man' | translate }}</th>
          <th>{{ 'Validas DE' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Im' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Man' | translate }}</th>
          <th>{{ 'Pendientes Rev.' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Im' | translate }}</th>
          <th [hidden]="!mostrarRiRm">{{ 'Man' | translate }}</th>
          <th>{{ '% Validas APPI' | translate }}</th>
          <th>{{ '% Validas DE' | translate }}</th>
          <th>{{ '% Pend. Rev.' | translate }}</th>
        </tr>
      </thead>

      <!-- DADOS -->
      <tbody>
        <tr *ngIf="isLoading" class="row-empty">
          <td [attr.colspan]="colspanVazio" class="empty-msg loading-msg">{{ 'Carregando...' | translate }}</td>
        </tr>
        <tr *ngIf="!isLoading && dados.length === 0" class="row-empty">
          <td [attr.colspan]="colspanVazio" class="empty-msg">
            <span *ngIf="semDados">{{ 'Nenhum dado encontrado para os filtros selecionados.' | translate }}</span>
            <span *ngIf="!semDados">{{ 'Selecione o País, o Ano e o Mês e clique em Consultar.' | translate }}</span>
          </td>
        </tr>
        <tr *ngFor="let row of dados; let i = index; trackBy: trackByRow"
            [class.row-alt]="i % 2 !== 0" [hidden]="isLoading">
          <td>{{ row.fechaProceso }}</td>
          <td>{{ formatEnvio(row) }}</td>
          <td class="num">{{ row.totalImagenes | number }}</td>
          <td class="num">{{ row.imagenesConError | number }}</td>
          <td class="num">{{ row.noSonRxs | number }}</td>
          <td class="num">{{ row.imagenesEnCola | number }}</td>
          <td class="num">{{ row.imagenesProcesadas | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ row.total_RX_RI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ row.total_RX_RM | number }}</td>
          <td class="num grp-appi-col">{{ row.validasAPPI | number }}</td>
          <td class="num grp-appi-col" [hidden]="!mostrarRiRm">{{ row.validasAPPI_RI | number }}</td>
          <td class="num grp-appi-col" [hidden]="!mostrarRiRm">{{ row.validasAPPI_RM | number }}</td>
          <td class="num grp-de-col">{{ row.validasDE | number }}</td>
          <td class="num grp-de-col" [hidden]="!mostrarRiRm">{{ row.validasDE_RI | number }}</td>
          <td class="num grp-de-col" [hidden]="!mostrarRiRm">{{ row.validasDE_RM | number }}</td>
          <td class="num grp-pend-col">{{ row.pendientesRevision | number }}</td>
          <td class="num grp-pend-col" [hidden]="!mostrarRiRm">{{ row.pendientesRevision_RI | number }}</td>
          <td class="num grp-pend-col" [hidden]="!mostrarRiRm">{{ row.pendientesRevision_RM | number }}</td>
          <td class="num pct grp-appi-col">{{ (row.imagenesProcesadas > 0 ? (row.validasAPPI / row.imagenesProcesadas * 100) : 0) | number:'1.1-2' }}%</td>
          <td class="num pct grp-de-col">{{ (row.imagenesProcesadas > 0 ? (row.validasDE / row.imagenesProcesadas * 100) : 0) | number:'1.1-2' }}%</td>
          <td class="num pct grp-pend-col">{{ (row.imagenesProcesadas > 0 ? (row.pendientesRevision / row.imagenesProcesadas * 100) : 0) | number:'1.1-2' }}%</td>
        </tr>
      </tbody>

      <!-- TOTAIS -->
      <tfoot *ngIf="dados.length > 0 && !isLoading">
        <tr class="total-row">
          <td colspan="2">{{ 'Total' | translate }}</td>
          <td class="num">{{ totais.totalImagenes | number }}</td>
          <td class="num">{{ totais.imagenesConError | number }}</td>
          <td class="num">{{ totais.noSonRxs | number }}</td>
          <td class="num">{{ totais.imagenesEnCola | number }}</td>
          <td class="num">{{ totais.imagenesProcesadas | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.total_RX_RI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.total_RX_RM | number }}</td>
          <td class="num">{{ totais.validasAPPI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.validasAPPI_RI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.validasAPPI_RM | number }}</td>
          <td class="num">{{ totais.validasDE | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.validasDE_RI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.validasDE_RM | number }}</td>
          <td class="num">{{ totais.pendientesRevision | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.pendientesRevision_RI | number }}</td>
          <td class="num" [hidden]="!mostrarRiRm">{{ totais.pendientesRevision_RM | number }}</td>
          <td class="num pct">{{ totais.pctValidasAPPI | number:'1.1-2' }}%</td>
          <td class="num pct">{{ totais.pctValidasDE | number:'1.1-2' }}%</td>
          <td class="num pct">{{ totais.pctPendientes | number:'1.1-2' }}%</td>
        </tr>
      </tfoot>

    </table>
  </div>
</div>
